import { render, staticRenderFns } from "./GuncellemelerInfo.vue?vue&type=template&id=60065b10&scoped=true"
import script from "./GuncellemelerInfo.vue?vue&type=script&lang=ts"
export * from "./GuncellemelerInfo.vue?vue&type=script&lang=ts"
import style0 from "./GuncellemelerInfo.vue?vue&type=style&index=0&id=60065b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60065b10",
  null
  
)

export default component.exports